import React, { forwardRef } from 'react';
import Imgix, { buildURL } from 'react-imgix';
import { replaceAWSSourceWithImgix } from '../helpers/imgix';

export const buildImgixSrc = (src, imgixParams) => {
  return buildURL(cleanImgixSrc(src), {
    ...imgixParams,
  });
};

export const cleanImgixSrc = (src) => {
  // Patching: https://github.com/imgix/react-imgix/issues/801
  // This ternary would be hit if a null or broken src was passed - imgixclient throws a hard error.
  // Instead, replace with a default for now.
  src = src?.includes('://') ? src : `https://images.dutchie.com/category-stock-photos/flower/flower-1.png`;
  // Replace S3 with Imgix
  src = replaceAWSSourceWithImgix(src);
  return src;
};

export const buildImgixSrcSet = (src, imgixParams) => {
  // Common DPI multipliers (1x, 2x, 3x)
  const dpiMultipliers = [1, 2, 3];

  return dpiMultipliers
    .map((dpi) => {
      const dpiParams = {
        ...imgixParams,
        dpr: dpi,
      };

      return `${buildImgixSrc(src, dpiParams)} ${dpi}x`;
    })
    .join(', ');
};

export default forwardRef(({ src, ...props }, ref) => {
  src = cleanImgixSrc(src);
  return <Imgix ref={ref} src={src} {...props} />;
});
